import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your Firebase configuration from earlier
const firebaseConfig = {
  apiKey: "AIzaSyBZC6mQQ02d8LohAk_bKkk43Uy9hueMEBQ",
  authDomain: "votingapp-c4b98.firebaseapp.com",
  projectId: "votingapp-c4b98",
  storageBucket: "votingapp-c4b98.firebasestorage.app",
  messagingSenderId: "903753746231",
  appId: "1:903753746231:web:7f274ed6f4b9d030ba3cb2",
  measurementId: "G-P8LWX6WPDX"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
